/**
 * 运行时 + 构建时配置（优先级：window.__YZFC_DATAV_CONFIG__ > process.env.VUE_APP_* > fallback）
 * 勿与 public/config.js 的 window.$website（Avue 大屏编辑器）混用。
 */

export function getRuntime() {
  if (typeof window !== 'undefined' && window.__YZFC_DATAV_CONFIG__ && typeof window.__YZFC_DATAV_CONFIG__ === 'object') {
    return window.__YZFC_DATAV_CONFIG__
  }
  return {}
}

function envString(key) {
  const v = process.env[key]
  if (v === undefined || v === null) return ''
  return String(v).trim()
}

export function pickString(runtimeKey, envKey, fallback = '') {
  const rt = getRuntime()
  if (rt[runtimeKey] != null && String(rt[runtimeKey]).trim() !== '') {
    return String(rt[runtimeKey]).trim()
  }
  const fromEnv = envString(envKey)
  if (fromEnv !== '') return fromEnv
  return fallback
}

export function pickBool(envKey, fallback = false) {
  const v = process.env[envKey]
  if (v === 'true') return true
  if (v === 'false') return false
  return fallback
}

export function getStage() {
  return (
    pickString('stage', 'VUE_APP_STAGE', '') ||
    (process.env.NODE_ENV === 'development' ? 'dev' : 'prod')
  )
}

export function getMqttRuntimeOverrides() {
  const rt = getRuntime()
  const m = rt.mqtt && typeof rt.mqtt === 'object' ? rt.mqtt : {}
  const out = {}

  const url = (m.url != null && String(m.url).trim()) || (rt.mqttUrl != null && String(rt.mqttUrl).trim()) || ''
  if (url) out.brokerUrl = url

  if (m.useTLS === true) out.useTLS = true
  if (m.useTLS === false) out.useTLS = false
  if (m.host) out.host = String(m.host).trim()
  if (m.port != null && m.port !== '') {
    const p = Number(m.port)
    if (!Number.isNaN(p)) out.port = p
  }
  if (m.path || m.endpoint) {
    const path = String(m.path || m.endpoint)
    out.endpoint = path.startsWith('/') ? path : `/${path}`
  }
  if (m.username != null && String(m.username) !== '') out.username = String(m.username)
  if (m.password != null && String(m.password) !== '') out.password = String(m.password)
  if (m.topic) out.topic = String(m.topic)

  if (m.reconnectPeriod != null && m.reconnectPeriod !== '') {
    const n = Number(m.reconnectPeriod)
    if (!Number.isNaN(n)) out.reconnectPeriod = n
  }
  if (m.keepalive != null && m.keepalive !== '') {
    const n = Number(m.keepalive)
    if (!Number.isNaN(n)) out.keepalive = n
  }
  if (m.simulateSwitch === true) out.simulateSwitch = true
  if (m.simulateSwitch === false) out.simulateSwitch = false

  return out
}
